import ModalContentDetail from './ModalContentDetail';

export default ModalContentDetail;
